import { z } from "zod";

export const BOOK_IDS = ["lunar", "hanukkah", "diwali", "friends"] as const;
export const FORMAT_IDS = ["soft", "hard", "flat"] as const;
export const GENDERS = ["boy", "girl", "neutral"] as const;

export const US_STATES = [
  "AL","AK","AZ","AR","CA","CO","CT","DE","FL","GA",
  "HI","ID","IL","IN","IA","KS","KY","LA","ME","MD",
  "MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ",
  "NM","NY","NC","ND","OH","OK","OR","PA","RI","SC",
  "SD","TN","TX","UT","VT","VA","WA","WV","WI","WY","DC",
] as const;

export const personalizeItemSchema = z.object({
  bookId: z.enum(BOOK_IDS),
  name: z.string().min(1).max(12),
  gender: z.enum(GENDERS),
  modelId: z.string().min(1).max(8),
  dedication: z.string().min(1).max(280),
  signature: z.string().min(1).max(60),
  format: z.enum(FORMAT_IDS),
});

export type PersonalizeItem = z.infer<typeof personalizeItemSchema>;

export const shippingAddressSchema = z.object({
  first: z.string().min(1).max(60),
  last: z.string().min(1).max(60),
  addr1: z.string().min(1).max(120),
  addr2: z.string().max(60).optional().or(z.literal("")),
  city: z.string().min(1).max(60),
  state: z.enum(US_STATES),
  zip: z.string().regex(/^\d{5}(-\d{4})?$/, "ZIP must be 5 or 9 digits"),
  country: z.literal("US").default("US"),
});

export type ShippingAddress = z.infer<typeof shippingAddressSchema>;

export const createOrderRequestSchema = z.object({
  email: z.string().email(),
  items: z.array(personalizeItemSchema).min(1).max(20),
  shipping: shippingAddressSchema,
});

export type CreateOrderRequest = z.infer<typeof createOrderRequestSchema>;

export const magicLinkRequestSchema = z.object({
  email: z.string().email(),
});

export type MagicLinkRequest = z.infer<typeof magicLinkRequestSchema>;

export const ORDER_STATUSES = ["pending", "paid", "fulfilled", "refunded", "failed"] as const;
export type OrderStatus = (typeof ORDER_STATUSES)[number];
